import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { DialogContent } from '../dialog-content';
import { DialogFooter } from '../dialog-footer';
import { DialogHeader } from '../dialog-header';
import type {
    ConfirmationAction,
    ConfirmationStatus,
    DialogConfirmButtonOptions,
    ProcessingAppearance,
} from '../models';

@Component({
    selector: 'qpx-confirmation-dialog',
    imports: [DialogHeader, DialogContent, DialogFooter],
    templateUrl: './confirmation-dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialog {
    //#region Inputs
    public readonly title = input('');
    public readonly status = input<ConfirmationStatus>('default');
    public readonly confirmButton = input<ConfirmationAction>('OK');
    public readonly cancelButton = input<false | ConfirmationAction>(false);
    public readonly confirmDisabled = input(false);
    public readonly isProcessing = input(false);
    public readonly processingAppearance = input<ProcessingAppearance>('body');
    //#endregion

    //#region Outputs
    public readonly dismiss = output<void>();
    public readonly confirm = output<void>();
    //#endregion

    //#region State
    protected readonly resolvedConfirmButton =
        computed<DialogConfirmButtonOptions>(() => {
            const action = this.confirmButton();
            const status = this.status();
            return {
                label: typeof action === 'string' ? action : action.label,
                icon: typeof action === 'string' ? '' : (action.icon ?? ''),
                theme: status === 'default' ? 'primary' : status,
            };
        });
    //#endregion
}
